export enum TripTypeEnum {
  ROUND_TRIP = 'Round Trip',
  ONE_WAY = 'One Way'
}
